var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{attrs:{"value":_vm.percent,"format":"percent","max":100,"rounded":true,"size":"is-small","type":"is-danger","show-value":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }